import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';

import { Product } from 'models';
import { validate } from 'models/validate';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';
import SupplementalMaterialsItem from 'components/SupplementalMaterials/SupplementalMaterialsItem';
import FileUpload from 'components/FileUpload';
import Input from './Input';

import { setObjPath, formatValue, keyedObjToArr } from '../util';

class ProductPanel extends Component {

	//Need to move state to here
	constructor (props) {
		super(props);
		//let productRecord = new Product();
		this.state = {
			product : this.props.product || {},
			materials: this.props.product ? this.props.product.materials : {}
		};
	}

	updateProduct (event) {
		let value = formatValue(event.target.value, event.target.type);

		let product = setObjPath(this.state.product, event.target.name, value);
		this.setState({
			product : product
		});
	}

	updateProductCover (fileId) {
		let product = this.state.product;
		product.cover = fileId;
		this.setState({
			product : product
		});
	}

	deleteFile(fileId){
		let materials = this.state.materials;
		delete materials[fileId];
		this.setState({
			materials: materials
		});
	}

	addFile(fileId, file){
        let materials = this.state.materials ? this.state.materials : {};
        materials[fileId] = file;
        this.setState({
            materials: materials
        });
	}

	render () {
		return (
			<div className="panel">
				<ContentHeader
					title={this.props.editing ? 'Editing Product ' + this.props.product.name + (this.props.product.active ? '' : ' (inactive)') : 'Create New Product'}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">
						<div className="panel-section">
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label for-large-input">Name</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<Input
												inputClass="large"
												placeholder="Product Name"
												name="name"
												value={this.props.product.name}
												onChange={this.updateProduct.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Description</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<Input
												placeholder="A brief description of your product"
												type="textarea"
												name="description"
												value={this.props.product.description}
												onChange={this.updateProduct.bind(this)}
											/>
											{/* <span>To be shown on agreements sent to customers. This can alway be edited per agreement.</span> */}
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Price</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<Input
												placeholder="Price"
												name="price"
												type="number"
												value={this.props.product.price}
												onChange={this.updateProduct.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Sort Order</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<Input
												placeholder="sort order"
												name="order"
												type="number"
												value={this.props.product.order}
												onChange={this.updateProduct.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Cover Image</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											<FileUpload
												product={this.state.product}
												updateProductCover={this.updateProductCover.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Product Id</label>
									</div>
									<div className="col-9">
										<div className="section-content">
                                            { !this.props.editing ? (
												<Input
													placeholder="product id"
													name="productId"
													type="text"
													value={this.props.product.productId}
													onChange={this.updateProduct.bind(this)}
												/>
                                            ) : (
												<span>{this.props.product.productId}</span>
                                            )}
										</div>
									</div>
								</div>
							</div>
							<div className="panel-row">
								<div className="row tight">
									<div className="col-3">
										<label className="section-label">Supplemental Materials</label>
									</div>
									<div className="col-9">
										<div className="section-content">
											{keyedObjToArr(this.state.materials).map((materialItem, index) => {
												return(<SupplementalMaterialsItem
													key={materialItem.id}
													product={this.state.product}
													file={materialItem}
													canEdit={true}
													canDelete={true}
													addFile={this.addFile.bind(this)}
													deleteFile={this.deleteFile.bind(this)}
												/>);
											})}
											<SupplementalMaterialsItem
												product={this.state.product}
												updateFilesList={this.addFile.bind(this)}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}
					onConfirm={ function () {
						validate(this.state.product, Product).then( (validatedProduct)=> {
							if(this.props.editing) {
								this.props.saveProduct(validatedProduct);
								this.props.addNotification('add-save-product-success-' + Date.now(), 'Product Saved');
							} else {
								this.props.addProduct(validatedProduct);
								this.props.addNotification('add-save-product-success-' + Date.now(), 'Product Added');
								this.props.closeDrawer();
							}
						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-product-error-' + Date.now(), error.message);
						});
					}.bind(this)}
					cancelLabel={this.props.cancelLabel}
					confirmLabel="Save Product"
				/>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

export default connect(
	null,
	mapDispatchToProps
)(ProductPanel);



// WEBPACK FOOTER //
// ./js/components/ProductPanel.js